module.exports = __webpack_public_path__ + "static/media/sp43.485c5135.JPG";